<template>
  <div>
    <div style="background: #edeae7">
      <div class="title-bar">
        <img
          style="margin-top: -2px"
          src="../../assets/img/home-icon.png"
          alt=""
        />
        <span style="margin-left: 5px; color: #666666; font-size: 12px"
          >您的位置：</span
        >
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/newslist?id=${currentItem}` }">{{
            currentItemName
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            `${currentItemName}详情`
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="main">
      <div class="newsDetail" :style="defSty">
        <h3>{{ item.name }}</h3>
        <span><i class="el-icon-time"></i>{{ item.createTime }}</span>
        <p v-html="item.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defSty: {
        'min-height': `${document.documentElement.clientHeight - 435}px`,
      },
      currentItem: '',
      currentItemName: '',
      item: {},
    }
  },
  created() {
    var list = JSON.parse(localStorage.getItem('item'))
    this.getContent(list)
    this.currentItem = this.$route.query.type
    this.currentItemName = this.getItem(Number(this.currentItem))
  },
  methods: {
    getItem(id) {
      switch (id) {
        case 1:
          return '标准'
          break
        case 2:
          return '政策'
          break
        case 3:
          return '公告'
          break
        default:
          break
      }
    },
    getContent(list) {
      this.item = list
    },
  },
}
</script>

<style scoped>
.title-bar {
  width: 1160px;
  margin: 0 auto;
  height: 36px;
  line-height: 36px;
  color: #666666;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.main {
  background-color: #f8f8f8;
  width: 100%;
}
.newsDetail {
  width: 1000px;
  background-color: #ffffff;
  padding: 40px 80px 60px 80px;
  margin: 0 auto;
}
.newsDetail h3 {
  width: 737px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin: 0 auto;
}
.newsDetail span {
  display: block;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 23px;
  margin: 10px auto;
  text-align: center;
}
.newsDetail span i {
  margin-right: 4px;
  font-size: 14px;
}
.newsDetail p {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
</style>
